import { Skeleton, Stack } from "@mui/material";

import HomePageCard from "./HomePageCard";

export const LoadingCard = ({ title }: { title: string }) => (
  <HomePageCard title={title}>
    <Stack sx={{ justifyContent: "space-between", p: 3, height: 177 }}>
      <Skeleton variant="rectangular" width="265px" height="36px" />
      <Skeleton variant="rectangular" width="191px" height="36px" />
    </Stack>
  </HomePageCard>
);
